export const CalendarIcon = ({ className }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.8594 15.2V16.8875L17.7594 17.9M9.85938 11H4.85938M20.8594 9V7C20.8594 5.89543 19.9639 5 18.8594 5H6.85938C5.75481 5 4.85938 5.89543 4.85938 7V19C4.85938 20.1046 5.75481 21 6.85938 21H9.85938M15.8594 3V7M9.85938 3V7M21.3594 17C21.3594 19.4853 19.3447 21.5 16.8594 21.5C14.3741 21.5 12.3594 19.4853 12.3594 17C12.3594 14.5147 14.3741 12.5 16.8594 12.5C19.3447 12.5 21.3594 14.5147 21.3594 17Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
